export interface BrujulaProps {
  /** Hacia dónde apunta la flecha, en grados desde el norte (0 N, 90 E…). */
  grados: number;
}

/** Una brújula chica con una flecha hacia `grados` (decorativa: el texto de al lado dice el rumbo). */
export function Brujula({ grados }: BrujulaProps) {
  return (
    <svg aria-hidden viewBox="0 0 76 76" className="size-16 shrink-0">
      <circle cx="38" cy="38" r="34" fill="var(--color-superficie)" stroke="var(--color-borde)" />
      <g fontSize="9" fontWeight="600" fill="var(--color-texto-suave)" textAnchor="middle">
        <text x="38" y="14">N</text>
        <text x="38" y="70">S</text>
        <text x="66" y="41">E</text>
        <text x="10" y="41">O</text>
      </g>
      <g transform={`rotate(${grados} 38 38)`}>
        <path d="M38 16 L44 40 L38 36 L32 40 Z" fill="var(--color-alerta)" />
        <circle cx="38" cy="38" r="3" fill="var(--color-texto)" />
      </g>
    </svg>
  );
}
